import styled from "@emotion/styled";

export const DropdownWrapper = styled.div`
  height: 5rem;
`;
